'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _templateObject = _taggedTemplateLiteral(['\n  font-family: ', ';\n  font-weight: ', ';\n  font-size: 13px;\n  margin-left: 5px;\n  margin-right: 5px;\n\n  label {\n    cursor: ', ';\n    color: ', ';\n\n    .radiobutton-label-left {\n      margin-right: 5px;\n    }\n\n    .radiobutton-label-right {\n      margin-left: 5px;\n    }\n  }\n\n  svg {\n    font-size: 14px;\n    vertical-align: middle;\n  }\n'], ['\n  font-family: ', ';\n  font-weight: ', ';\n  font-size: 13px;\n  margin-left: 5px;\n  margin-right: 5px;\n\n  label {\n    cursor: ', ';\n    color: ', ';\n\n    .radiobutton-label-left {\n      margin-right: 5px;\n    }\n\n    .radiobutton-label-right {\n      margin-left: 5px;\n    }\n  }\n\n  svg {\n    font-size: 14px;\n    vertical-align: middle;\n  }\n']);
var _styledComponents = require('styled-components');
var _styledComponents2 = _interopRequireDefault(_styledComponents);
var _RadioButtonBase = require('./RadioButtonBase');
var _RadioButtonBase2 = _interopRequireDefault(_RadioButtonBase);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    'default': obj
  };
}
function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}
var RadioButton = (0, _styledComponents2['default'])(_RadioButtonBase2['default'])(_templateObject, function (props) {
  return props.theme.fontFamily;
}, function (props) {
  return props.theme.fontWeightRegular;
}, function (props) {
  return props.disabled ? 'not-allowed' : 'pointer';
}, function (props) {
  return props.theme.colorTextDark;
});
exports['default'] = RadioButton;